import { useEffect, useState } from "react";

export const MEDIA_MD = "(min-width: 768px)";
export const MEDIA_LG = "(min-width: 1024px)";

export function useMediaQuery(query: string): boolean {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		const list = window.matchMedia(query);
		const update = () => setMatches(list.matches);
		update();
		list.addEventListener("change", update);
		return () => list.removeEventListener("change", update);
	}, [query]);

	return matches;
}
